import { HStack } from '@chakra-ui/react'
import isEmpty from 'lodash/isEmpty'
import type { FC } from 'react'
import { useState } from 'react'

import { Button } from '@app/components/ui/button'
import { EmptyState, type EmptyStateProps } from '@app/components/ui/empty-state'
import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import ContextEditModal from '@app/pages/maps/components/contextEditModal'
import GenerateContextDialog from '@app/pages/maps/components/generateContextDialog'
import Can from '@app/shared/authorization/can'
import type { DomainBusinessContext } from '@app/types'
import { TaskStatusesEnum } from '@graphql/types'

interface Props extends Omit<EmptyStateProps, 'title'> {
  businessContext?: DomainBusinessContext
}

const ContextEmptyState: FC<Props> = ({ businessContext = null, ...rest }) => {
  const [open, setOpen] = useState(false)
  const tasks = useGetObjectsByProperties('task', {
    domainObjectType: !businessContext?.parentBusinessContextId ? 'Organization' : 'BusinessContext',
    domainObjectId: !businessContext?.parentBusinessContextId ? businessContext?.organizationId : businessContext?.id,
    status: TaskStatusesEnum.InProgress
  })

  if (businessContext && businessContext?.content && !isEmpty(businessContext?.content)) {
    return null
  }

  return (
    <EmptyState
      size="sm"
      title="No context"
      description={`No context has been generated for your ${businessContext?.parentBusinessContextId ? 'folder' : 'organization'} at this time.`}
      {...rest}
    >
      <Can I="create" a="businessContext">
        <HStack>
          <GenerateContextDialog
            businessContext={businessContext}
            open={open}
            onOpenChange={(e) => setOpen(e.open)}
            loading={!!tasks.length}
          />

          {businessContext && (
            <ContextEditModal businessContext={businessContext} title="Add Business Context">
              <Button colorPalette="purple" variant="surface">
                Fill in manually
              </Button>
            </ContextEditModal>
          )}
        </HStack>
      </Can>
    </EmptyState>
  )
}

export default ContextEmptyState
